module.exports = __webpack_public_path__ + "static/banner-5-eb5d966dbf863f562dd1ebbb3f34fa28.png";